/* Ayudate · Formato de texto y montos */

import { infoCurso } from "../datos/areas";

export const colones = (n) => "₡" + Number(n || 0).toLocaleString("es-CR");

/* Normaliza para buscar: sin acentos y en minúscula. */
export const norm = (t) => (t || "").toLowerCase()
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "");

/* "javier TRUJILLO soto" → "Javier Trujillo Soto", respetando partículas. */
const PARTICULAS = ["de", "del", "la", "las", "los", "y", "da", "das", "dos", "van", "von"];
export const capitalizar = (n) => (n || "").trim().replace(/\s+/g, " ").split(" ")
  .map((p, i) => {
    const b = p.toLowerCase();
    if (i > 0 && PARTICULAS.includes(b)) return b;
    return b.charAt(0).toUpperCase() + b.slice(1);
  }).join(" ");

/* Cómo se nombra un curso en toda la interfaz: con su código adelante
   cuando lo tiene ("MA1102 · Cálculo Diferencial e Integral") y con el
   nombre solo cuando no ("Inglés Intermedio"). Vive acá porque lo usan los
   tres paneles y hasta ahora solo el del tutor lo hacía, con un mapa propio
   que además duplicaba el nombre de los cursos sin código. */
export const nombreCurso = (cod) => {
  const i = infoCurso(cod);
  return i.sinCodigo ? i.nom : `${i.cod} · ${i.nom}`;
};

/* "Mariana Solís" → "MS" */
export const iniciales = (nombre) =>
  (nombre || "").trim().split(/\s+/).slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "").join("") || "??";
